import script from "./LineIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LineIcon.vue?vue&type=script&setup=true&lang=js"

import "./LineIcon.vue?vue&type=style&index=0&id=1a8fb4db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8fb4db"]])

export default __exports__